import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { OTSession, OTStreams, preloadScript } from 'opentok-react';
import Timer from './Timer';
import Publisher from './Publisher';
import Subscriber from './Subscriber';
import i18n from '../../../config/i18n';

const desktopPublisherVideoSize = { width: 120, height: 90 };
const mobilePublisherVideoSize = { width: 60, height: 45 };
const desktopSubscriberVideoSize = { width: 640, height: 480 };
const mobileSubscriberVideoSize = { width: 240, height: 180 };

const styles = {
  publisherCamera: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 2,
  },
  subscriberCamera: {
    position: 'relative',
    zIndex: 1,
  },
  camerasDiv: {
    position: 'relative',
    ...desktopSubscriberVideoSize,
  },
  mobileCamerasDiv: {
    position: 'relative',
    ...mobileSubscriberVideoSize,
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  block: {
    display: 'block',
  },
};

class VideoChat extends Component {
  static proptypes = {
    actions: PropTypes.shape({
      createDangerAlert: PropTypes.func.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
    endedAt: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      connected: false,
    };

    this.sessionEvents = {
      sessionConnected: () => {
        this.setState({ connected: true });
      },
      sessionDisconnected: () => {
        this.setState({ connected: false });
      },
    };
  }

  componentWillMount() {
    // OT.registerScreenSharingExtension('chrome', config.CHROME_EXTENSION_ID, 2);
  }

  onError = (err) => {
    this.setState({ error: `Failed to connect: ${err.message}` });
  };

  render() {
    const {
      actions,
      createdAt,
      endedAt,
      isMobile,
    } = this.props;

    return (
      <OTSession
        apiKey={this.props.apiKey}
        sessionId={this.props.sessionId}
        token={this.props.token}
        eventHandlers={this.sessionEvents}
        onError={this.onError}
      >
        <div style={styles.center}>
          <div style={styles.block}>
            <div>
              {this.state.error ? <div>{this.state.error}</div> : null}
              <div>
                <strong>{i18n.t('status')}: </strong>
                {this.state.connected ? i18n.t('connected') : i18n.t('disconnected')}
              </div>
              <Timer
                actions={actions}
                createdAt={createdAt}
                endedAt={endedAt}
              />
            </div>
            <br />
            <div style={isMobile ? styles.mobileCamerasDiv : styles.camerasDiv}>
              <div style={styles.subscriberCamera}>
                <OTStreams>
                  <Subscriber
                    videoDimensions={
                      isMobile
                        ? mobileSubscriberVideoSize
                        : desktopSubscriberVideoSize
                    }
                  />
                </OTStreams>
              </div>
              <div style={styles.publisherCamera}>
                <Publisher
                  actions={actions}
                  videoDimensions={
                    isMobile
                      ? mobilePublisherVideoSize
                      : desktopPublisherVideoSize
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </OTSession>
    );
  }
}

export default preloadScript(VideoChat);



// WEBPACK FOOTER //
// ./src/components/messaging/videoChat/VideoChat.js